const BACK_OFFICE_ENTRIES_URL = "/entry/entries-adjustment-tools";

export default [
  {
    level: 3,
    key: "title.adjustSingleEntry",
    link: `${BACK_OFFICE_ENTRIES_URL}/adjust-single-entry`,
  },
  {
    level: 3,
    key: "title.adjustCostItemEntries",
    link: `${BACK_OFFICE_ENTRIES_URL}/adjust-cost-item-entries`,
  },
  {
    level: 3,
    key: "title.revaluationJournalAllItems",
    link: `${BACK_OFFICE_ENTRIES_URL}/revaluation-journal-all-items`,
  },
];
